import { render, staticRenderFns } from "./AdmissionView.vue?vue&type=template&id=3738e860&scoped=true&"
import script from "./AdmissionView.vue?vue&type=script&lang=js&"
export * from "./AdmissionView.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionView.vue?vue&type=style&index=0&id=3738e860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738e860",
  null
  
)

export default component.exports